import script from "./ListProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./ListProducts.vue?vue&type=script&setup=true&lang=js"

import "./ListProducts.vue?vue&type=style&index=0&id=5ca89a63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca89a63"]])

export default __exports__